<template>
  <sSelect
    v-if="editMode"
    data-qa="type-selector"
    :placeholder="$t('AdditionalFields.FieldType')"
    :value.sync="model">
    <sOption
      v-for="item_type in types.filter(el => el.type)"
      :key="`item-${item_type.type}`"
      class="px-8"
      :data-qa="`item-${item_type.type}`"
      :label="item_type.text"
      :value="item_type.type">
      {{ item_type.text }}
    </sOption>
  </sSelect>
  <div
    v-else
    class="v-input flex flex-wrap flex-direction-column">
    <v-menu
      content-class=" menu"
      offset-y>
      <template v-slot:activator="{ on, value: active }">
        <v-chip
          class="black--text  menu open-folter-dialog-chip type-chip mt-1 mb-3"
          v-on="on">
          {{ model && model.length ? $t('Releases.' + model) : $t('Common.Type') }}
          <div class="spacer"/>
          <sIcon
            :rotate="active ? '180' : ''"
            size="10"
            type="arrow"/>
        </v-chip>
      </template>
      <v-list
        class="menu"
        dense>
        <v-list-item
          v-for="item in types.filter(el => el.type)"
          :key="item.type"
          @click="model = item.type">
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { releaseMixin } from 'mixins'

export default {
  name: 'typeSelect',
  mixins: [ releaseMixin ],
  props: {
    value: [String, Array],
    /**
     * Костыль что б в фильтре остался старый компонент.
     * Сейчас не та задача что б переделывать фильтры.
     * С новым компонентом возникает конфликт по сворачиванию
     */
    editMode: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      }
    },
  },
}
</script>
